<div class="content_card fadeInRight">
    <ng-content></ng-content>
</div>